import { render, staticRenderFns } from "./PoiTitle.vue?vue&type=template&id=207dda0a&"
import script from "./PoiTitle.vue?vue&type=script&lang=js&"
export * from "./PoiTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports